<!-- <svelte:options customElement="clever-search-rating" /> -->

<script lang="ts">
  import { state_answerRating } from '../../../store/state';

  import { _ } from 'svelte-i18n';

  export let updateTimer: any;
  export let updateSuccess: boolean;
  export let updateFail: boolean;

  export let isUpdating: boolean;
  export let sendRating: any;
</script>

<!-- default loading is thumbs view-->

<button
  class="cs-thumb"
  class:busy={isUpdating}
  class:active={$state_answerRating?.score == 1}
  aria-label={$_('rating.thumbs_up')}
  title={$_('rating.thumbs_up')}
  on:keypress={() => sendRating(1)}
  on:click={() => sendRating(1)}
>
  <svg
    width="19"
    height="19"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.26855 10.4195L5.977 11.7422C6.19744 11.9627 6.69344 12.0729 7.02411 12.0729H9.11833C9.77967 12.0729 10.4961 11.5769 10.6614 10.9155L11.9841 6.89244C12.2597 6.12088 11.7637 5.45955 10.937 5.45955H8.73255C8.40189 5.45955 8.12633 5.18399 8.18144 4.79821L8.457 3.03466C8.56722 2.53866 8.23655 1.98755 7.74055 1.82221C7.29967 1.65688 6.74855 1.87733 6.52811 2.20799L4.26855 5.56977"
      stroke="currentColor"
      stroke-width="0.826667"
      stroke-miterlimit="10"
    />
    <path
      d="M1.45898 10.4196V5.01867C1.45898 4.24711 1.78965 3.97156 2.56121 3.97156H3.11232C3.88387 3.97156 4.21454 4.24711 4.21454 5.01867V10.4196C4.21454 11.1911 3.88387 11.4667 3.11232 11.4667H2.56121C1.78965 11.4667 1.45898 11.1911 1.45898 10.4196Z"
      stroke="currentColor"
      stroke-width="0.826667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
<button
  class="cs-thumb busy down"
  class:busy={isUpdating}
  class:active={$state_answerRating?.score == 0}
  aria-label={$_('rating.thumbs_down')}
  title={$_('rating.thumbs_down')}
  on:keypress={() => sendRating(0)}
  on:click={() => sendRating(0)}
>
  <svg
    width="19"
    height="19"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0909 3.42055L8.38247 2.09788C8.16203 1.87743 7.66603 1.76721 7.33536 1.76721H5.24114C4.57981 1.76721 3.86336 2.26321 3.69803 2.92455L2.37536 6.94766C2.09981 7.71921 2.59581 8.38055 3.42247 8.38055H5.62692C5.95759 8.38055 6.23314 8.6561 6.17803 9.04188L5.90247 10.8054C5.79225 11.3014 6.12292 11.8525 6.61892 12.0179C7.05981 12.1832 7.61092 11.9628 7.83136 11.6321L10.0909 8.27032"
      stroke="currentColor"
      stroke-width="0.826667"
      stroke-miterlimit="10"
    />
    <path
      d="M12.902 3.4204V8.82129C12.902 9.59285 12.5714 9.8684 11.7998 9.8684H11.2487C10.4772 9.8684 10.1465 9.59285 10.1465 8.82129V3.4204C10.1465 2.64885 10.4772 2.37329 11.2487 2.37329H11.7998C12.5714 2.37329 12.902 2.64885 12.902 3.4204Z"
      stroke="currentColor"
      stroke-width="0.826667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>

<style lang="scss">
  @use './../../../../scss/components/themes/rating-theme/rating-theme';
</style>
